<!--
  @Description 接口分析
  @Date 2022-07-27
  @Author liushuo
-->
<template>
  <div class="container">
    <homeHeader title="接口分析"></homeHeader>
    <div class="main">
      <div class="card">
        <div
          :style="{
            height: tableHeight,
          }"
          id="frame"
        >
          <iframe
            :src="iframeUrl"
            frameborder="0"
            width="100%"
            :height="tableHeight"
            class="iframe-dv"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BASEURL } from '../../axios/baseUrlConfig'

export default {
  data() {
    return {
      iframeUrl: BASEURL.analysisUrl,
      tableData: [],
      // 列设置
      tableColumns: [],
      buttonVisible: {
        lock: false, // 锁定按钮是否显示
        unlock: false, // 解锁按钮是否显示
        update: false,
        delete: false,
        sort: false, // 排序按钮是否显示
        search: false, // 查找按钮是否显示
        more: false, // 更多按钮是否显示
      },
      // 明细验证规则
      validRules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'change' },
          {
            min: 0,
            max: 5,
            message: '姓名长度应在 0 到 5 个字符',
            trigger: 'change',
          },
        ],
        num: [
          { required: true, message: '请输入用户名', trigger: 'change' },
          {
            min: 0,
            max: 32,
            message: '用户名长度应在 0 到 32 个字符',
            trigger: 'change',
          },
        ],
        post: [
          { required: true, message: '请输入职位', trigger: 'change' },
          {
            min: 0,
            max: 32,
            message: '职位长度应在 0 到 32 个字符',
            trigger: 'change',
          },
        ],
        sex: [
          { required: true, message: '请输入性别', trigger: 'change' },
          {
            min: 0,
            max: 1,
            message: '性别长度应在 0 到 1 个字符',
            trigger: 'change',
          },
        ],
        tel: [
          {
            min: 0,
            max: 20,
            message: '电话长度应在 0 到 20 个字符',
            trigger: 'change',
          },
        ],
        eMail: [
          {
            min: 0,
            max: 64,
            message: '邮箱长度应在 0 到 64 个字符',
            trigger: 'change',
          },
        ],
        feiShuID: [
          { required: true, message: '请输入飞书ID', trigger: 'change' },
          {
            min: 0,
            max: 64,
            message: '飞书ID长度应在 0 到 64 个字符',
            trigger: 'change',
          },
        ],
      },
      bodyMenus: [
        [
          {
            code: 'sex',
            name: '男',
          },
          {
            code: 'sex',
            name: '女',
          },
          {
            code: 'post',
            name: '选择职位',
          },
          {
            code: 'clearPosition',
            name: '清空',
          },
        ],
      ],
      // 拓展按钮
      moreButtonList: [],
      // check全选查找值
      checkBoxAll: false,
      //右键缓存
      areas: {},
      colProperty: '',
      selectVisiblePositionArr: [],
      // 获取权限
      Authority: this.AuthorityFilter(this.$route.path),
      // 下拉框
      positionOptions: [],
      // 是否修改
      IfExistModify: false,
      // 校验
      errIndex: [],
      // 特殊权限-重置密码
      ifResetPwd: false,
    }
  },
  methods: {
    // 初始化界面
    InitSetting() {
      for (let item of this.Authority.special) {
        if (item.name === 'resetpwd') {
          this.ifResetPwd = true
        }
      }
      this.moreButtonList = [
        {
          name: '重置密码',
          icon: 'el-icon-key',
          visible: this.ifResetPwd,
          event: 'handleResetPassword',
        },
      ]
    },
    // 获取数据
    async BindData() {
      let tableData = []
      this.tableData = []
      const { data: res } = await this.$http.post('/Common/YKUser/list', {
        pageIndex: 1,
        pageSize: 99999,
        seeType: this.Authority.seeType,
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      tableData = res.data.rows
      this.tableData = tableData.map((item) => {
        item.isSave = true
        item.isCheck = false
        return item
      })
    },
    // 刷新数据
    refresh() {
      this.BindData()
    },
    // 绑定下拉框
    async BindComBox() {
      this.positionOptions = []
      const { data: selectRes } = await this.$http.get(
        '/Common/YKUser/select-item'
      )
      if (selectRes.isSuccess) {
        for (let item of selectRes.data) {
          switch (item.code) {
            case 'UserPost':
              this.positionOptions.push(item)
              break
          }
        }
      }
    },
    // 重置密码
    async handleResetPassword() {
      if (!this.ifResetPwd) {
        this.$message.error('您没有相关权限！')
        return
      }
      // todo 初始密码为YKtec123456
      const successNameList = []
      const errorNameList = []
      let count = 0
      for (let item of this.tableData) {
        if (item.isCheck) {
          count += 1
          const { data: res } = await this.$http.put(
            `/Common/YKUser/resetpwd?ID=${item.id}`
          )
          if (!res.isSuccess) {
            errorNameList.push(item.name)
            return false
          }
          successNameList.push(item.name)
        }
      }
      if (count === 0) {
        this.$message.error('请选择需要重置密码的人员!')
        return
      }
      if (errorNameList.length > 0) {
        this.$message.error(
          '重置密码执行结束' +
            (successNameList.length > 0
              ? ',成功人员为: ' + successNameList.join(',')
              : '') +
            ',失败人员为: ' +
            errorNameList.join(',')
        )
      } else {
        this.$message.success('操作成功!')
      }
    },
    // sureBackPerson (PersonList) {
    //   console.log(PersonList)
    // },
    // 返回职位
    sureBackPosition(post) {
      this.areas.forEach((area) => {
        for (let row of area.rows) {
          for (let col of area.cols) {
            switch (col.property) {
              case 'post':
                row[col.property] = post
                break
            }
          }
        }
      })
    },
    cellContextMenuEvent({ column }) {
      this.areas = this.$refs.xTable.getCellAreas()
      this.colProperty = column.property
      // if (column.property === 'post') {
      //   this.$refs.PickPosition.formVisible = true
      // }
    },
    // 右键控制菜单方法
    visibleMethod({ options, column }) {
      // 显示之前处理按钮的操作权限
      options.forEach((list) => {
        list.forEach((item) => {
          item.disabled = !this.Authority.edit
          switch (column.property) {
            case 'sex':
              item.code === 'sex'
                ? (item.visible = true)
                : (item.visible = false)
              break
            case 'post':
              item.code === 'post' || item.code === 'clearPosition'
                ? (item.visible = true)
                : (item.visible = false)
              break
            default:
              item.visible = false
          }
        })
      })
      return true
    },
    // 右键确认
    contextMenuClickEvent({ menu, row }) {
      if (menu.code === 'sex' || menu.code === 'clearPosition') {
        this.areas.forEach((area) => {
          for (let row of area.rows) {
            for (let col of area.cols) {
              switch (col.property) {
                case 'sex':
                  row[col.property] = menu.name
                  break
                case 'post':
                  row[col.property] = ''
                  break
              }
            }
          }
        })
      } else if (menu.code === 'post') {
        this.selectVisiblePositionArr = []
        if (!row['post'] || row['post'] === '') {
          this.selectVisiblePositionArr = []
        } else if (
          row['post'] !== '' &&
          String(row['post']).indexOf(',') === -1
        ) {
          this.selectVisiblePositionArr = [row['post']]
        } else {
          this.selectVisiblePositionArr = String(row['post']).split(',')
        }
        this.$refs.PickPosition.formVisible = true
      }
    },
    // 初始化
    InitColumn() {
      this.tableColumns = [
        {
          type: 'seq',
          width: '40',
        },
        {
          field: 'delete',
          title: '删除',
          width: '50',
          visible: this.Authority.edit,
          align: 'center',
          slots: {
            default: ({ row }) => {
              return [
                <i
                  id="vxeDelete"
                  class="el-icon-delete-solid"
                  onClick={() => {
                    this.handleCellDelete(row)
                  }}
                ></i>,
              ]
            },
          },
        },
        {
          width: '50px',
          visible: this.Authority.edit,
          slots: {
            default: ({ row }) => {
              return [
                <vxe-checkbox
                  v-model={row.isCheck}
                  disabled={!row.isSave}
                ></vxe-checkbox>,
              ]
            },
            header: () => {
              return [
                <vxe-checkbox
                  v-model={this.checkBoxAll}
                  onChange={() => {
                    this.checkBoxChangeAll()
                  }}
                />,
              ]
            },
          },
        },
        {
          field: 'name',
          title: '姓名',
          editRender: { name: 'input' },
        },
        {
          field: 'num',
          title: '用户名',
          editRender: { name: 'input' },
        },
        {
          field: 'post',
          title: '职位',
          editRender: { name: '$input', attrs: { disabled: true } },
        },
        {
          field: 'sex',
          title: '性别',
          editRender: { name: '$input', attrs: { disabled: true } },
        },
        {
          field: 'tel',
          title: '电话',
          editRender: { name: 'input' },
        },
        {
          field: 'eMail',
          title: '邮箱',
          editRender: { name: 'input' },
        },
        {
          field: 'feiShuID',
          title: '飞书ID',
          editRender: { name: 'input' },
        },
      ]
    },
    // 全选
    checkBoxChangeAll() {
      const tableData = this.$refs.xTable.getTableData().fullData
      for (let item of tableData) {
        if (item.isSave) {
          item.isCheck = this.checkBoxAll
        }
      }
    },
    add() {
      this.$refs.xTable.insertAt({ id: 0, isCheck: false }, -1)
    },
    save() {
      const that = this
      // 保存dgv数据
      that.validEnter().then(async (result) => {
        if (result) {
          let insertRecords = that.$refs.xTable.getInsertRecords()
          let removeRecords = that.$refs.xTable.getRemoveRecords()
          let updateRecords = that.$refs.xTable.getUpdateRecords()
          // that.form.setName = that.setName
          // let form = { ...that.form }
          let detailList = []
          for (let item of insertRecords) {
            item.id = 0
            detailList.push(item)
          }
          for (let item of removeRecords) {
            item.id = item.id > 0 ? 0 - item.id : item.id
            detailList.push(item)
          }
          for (let item of updateRecords) {
            detailList.push(item)
          }
          detailList = that.removeArrayNull(detailList)
          if (detailList.length === 0) {
            that.$XModal.alert({
              message: that.messageConfig.emptyDataForSave,
              status: 'error',
            })
            return
          }
          // 保存节点信息
          const { data: res } = await that.$http.post(
            '/Common/YKUser/updatelist',
            detailList
          )
          if (res.isSuccess) {
            that.BindData()
            that.$message.success(res.data)
            that.IfExistModify = false
          } else {
            that.$message.error(res.errorMessage)
          }
        }
      })
    },
    // 验证
    async validEnter() {
      this.errIndex = []
      this.removeEmptyForTable(this.$refs.xTable)
      // 判重
      // this.repeatForTable(this.errIndex, this.$refs.xTable, ['displayMember'])
      // if (this.errIndex.length > 0) {
      //   return false
      // }
      const errMap = await this.$refs.xTable
        .fullValidate()
        .catch((errMap) => errMap)
      if (errMap) {
        Object.values(errMap).forEach((errList) => {
          errList.forEach((params) => {
            let { row, columnIndex, rules } = params
            rules.forEach(() => {
              this.errIndex.push({
                _XID: row._XID,
                columnIndex: columnIndex,
              })
            })
          })
        })
        if (this.errIndex.length > 0) {
          this.$message.error('验证失败,请核对输入数据')
        }
        return false
      } else {
        return true
      }
    },
    // 删除行
    handleCellDelete(row) {
      if (row.num === 'admin') {
        this.$message.error('管理员不可删除')
        return
      }
      this.$confirm('确定要删除本行吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$refs.xTable.remove(row)
          this.IfExistModify = true
        })
        .catch(() => {})
    },
    // cell激活控制
    activeMethod({ column }) {
      if (
        column.editRender &&
        column.editRender.attrs &&
        column.editRender.attrs.disabled === true
      ) {
        return false
      }
      if (!this.Authority.edit) {
        return false
      }
      return true
    },
    // cell编辑控制
    editMethod({ row, column, $table }) {
      if (
        column.editRender &&
        column.editRender.attrs &&
        column.editRender.attrs.disabled === true
      ) {
        return false
      }
      if (!this.Authority.edit) {
        return false
      }
      row[column.property] = null
      $table.setActiveCell(row, column.property)
      return true
    },
  },
  computed: {
    tableHeight() {
      let isSearchForm = this.searchFormVisible
      // 若有查询框，则共有四段 margin 否则只有表格的两段 margin
      let topBottomMargin = 20
      let tableMargin = isSearchForm
        ? this.heightConfig.mainMargin * 4
        : this.heightConfig.mainMargin * 2 + topBottomMargin
      let isToolBar = false
      return this.tableHeightComputed(tableMargin, isSearchForm, isToolBar)
    },
  },
}
</script>

<style lang="less" scoped>
@main-margin: 15px;
.main {
  width: 100%;
  margin: 0 auto;
  height: calc(100vh - @header-height);
  overflow: hidden;
}
.card {
  margin: @main-margin;
  box-shadow: #bebebe 2px 2px 10px;
  border-radius: 10px;
  overflow: hidden;
  background-color: #f7f7f7;
}

.table-dv {
  padding: @topBottomMargin;
}

.vxe-checkbox {
  width: 15px !important;
}

.main-menu {
  display: none !important;
}

// marginTop: -53px 为了去掉顶栏的显示
.iframe-dv {
  margin-top: -53px;
}
</style>
